var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"game-list"},_vm._l((_vm.games),function(game,index){return _c('GameCard',{key:index,attrs:{"image":game.image,"name":game.name,"value":game.value}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }